import { useEffect, useState } from "react";
import { getFormPrefixList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Distinct PolicyTypeDesc strings from /lookup/GetFormPrefixList — same shape
// as the Policy Inventory Lookup tab's Policy Type dropdown.
export function usePolicyTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getFormPrefixList().then((rows) => {
      if (!mounted) return;
      const seen = new Set<string>();
      const opts: OptionRenderType[] = [];
      for (const r of rows) {
        const label = r.PolicyTypeDesc;
        const value = r.ProductTypeAbbr;
        if (!label || !value) continue;
        const key = `${label}__${value}`;
        if (seen.has(key)) continue;
        seen.add(key);
        opts.push({ label, value });
      }
      setOptions(opts);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
